import i18n from './vue-i18n'

export { i18n }



// WEBPACK FOOTER //
// ./src/plugins/index.js